import Link from 'next/link'

type Breadcrumb = {
  label: string
  href: string
}
interface BreadcrumbType {
  breadcrumbs: Breadcrumb[]
  className?: string
  homeText?: string
  linkType?: string
}

const PageBreadcrumb = ({
  breadcrumbs,
  homeText = 'Trang chủ',
  className = '',
  linkType,
}: BreadcrumbType) => {
  return (
    <div className={`breadCrumb py-4 ${className}`}>
      <ul className='flex !list-none items-center gap-1 text-base text-dark-400'>
        <li key='breadcumb-10000'>
          <Link
            href={linkType === 'post' ? '/post' : '/'}
            className='home block text-primary'
          >
            {homeText}
          </Link>
        </li>
        <li className='divider text-primary'>{'/'}</li>
        {breadcrumbs.map((e: Breadcrumb, index: number) => (
          <li className='divider' key={`breadcumb-${e.label}`}>
            <Link href={e.href} className='home block text-primary'>
              {e.label}
            </Link>
            {index > 0 && <span className='divider'>{'>'}</span>}
          </li>
        ))}
      </ul>
    </div>
  )
}
export default PageBreadcrumb
